// components/common/CurrencyCodeAdd.jsx
import React from 'react';
import { useSelector } from 'react-redux';

const CurrencyCodeAdd = ({ price }) => {
  const { generalSetting } = useSelector((s) => s?.GeneralSetting || {});

  // safe fallbacks
  const symbol =
    (generalSetting?.site_default_currency_symbol ??
      generalSetting?.site_default_currency?.symbol ?? // if your settings include the whole currency object
      generalSetting?.currency?.symbol ??               // any other place you store it
      '$')                                              // final fallback
      .toString()
      .trim();

  const decimalsRaw = generalSetting?.site_digit_after_decimal_point;
  const decimals = Number.isInteger(Number(decimalsRaw))
    ? Number(decimalsRaw)
    : 2;

  const pos = String(generalSetting?.site_currency_position || '1'); // '1' = before, '2' = after

  const amount = Number(price ?? 0);
  const formatted = isFinite(amount) ? amount.toFixed(decimals) : Number(0).toFixed(decimals);

  return pos === '2' ? (
    <>{formatted} {symbol}</>
  ) : (
    <>{symbol} {formatted}</>
  );
};

export default CurrencyCodeAdd;
